import { render, staticRenderFns } from "./KisPersonEditDialog.vue?vue&type=template&id=40a4c188"
import script from "./KisPersonEditDialog.js?vue&type=script&lang=js&external"
export * from "./KisPersonEditDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports